import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { FilePage } from './FilePage';
import { CtaButton } from './CtaButton';
import { PRIMARY_CTA_ID } from '../data/checkout';
export function ClosingFile() {
  return <FilePage id="cierre" number="08" label="Cierre · La Decisión" data-id="element-139" data-mp="hofwbm6aytje">
      <p className="max-w-[42rem] font-display text-[1.4rem] font-bold leading-snug text-bone sm:text-[2.1rem]" data-id="element-140" data-mp="mov7q870xqyq">
        Tienes dos caminos ahora mismo.
      </p>

      <div className="mt-6 grid gap-4 sm:mt-9 sm:gap-5 md:grid-cols-2" data-id="element-141" data-mp="3q5anw5hngri6">
        <motion.article initial={{
        opacity: 0,
        x: -24,
        rotate: -1.2
      }} whileInView={{
        opacity: 1,
        x: 0,
        rotate: -0.6
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.6
      }} className="relative rounded-xl border border-signal-pink/30 bg-[linear-gradient(180deg,rgba(255,47,146,0.07),transparent)] p-5 sm:p-7" data-id="element-142" data-mp="3v56so6y68mys">
          <span className="flex items-center gap-2 font-mono text-[10px] font-extrabold uppercase tracking-[0.16em] text-signal-pink" data-id="element-143" data-mp="37d9focizjow3">
            <TrendingDown aria-hidden="true" className="h-4 w-4" data-id="element-144" data-mp="6as5xg922689" />
            Camino A
          </span>
          <p className="mt-4 text-[14.5px] leading-relaxed text-ash" data-id="element-145" data-mp="1jjuyfs2ucsz">
            Seguir intentando adivinar prompts, publicando contenido genérico y
            viendo cómo tu alcance muere lentamente.
          </p>
          <motion.span initial={{
          opacity: 0,
          scale: 2,
          rotate: -20
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: -11
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.55,
          delay: 0.3
        }} className="absolute -bottom-2.5 right-5 rounded border-2 border-signal-pink/80 bg-ink/70 px-2.5 py-1 font-mono text-[10px] font-extrabold tracking-[0.14em] text-signal-pink" data-id="element-146" data-mp="3opt0kkhy3gdh">
            RECHAZADO
          </motion.span>
        </motion.article>

        <motion.article initial={{
        opacity: 0,
        x: 24,
        rotate: 1.2
      }} whileInView={{
        opacity: 1,
        x: 0,
        rotate: 0.6
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.6,
        delay: 0.08
      }} className="relative rounded-xl border border-gold/35 bg-[linear-gradient(180deg,rgba(212,175,55,0.12),transparent)] p-5 sm:p-7" data-id="element-147" data-mp="1816ygl3ztahs">
          <span className="flex items-center gap-2 font-mono text-[10px] font-extrabold uppercase tracking-[0.16em] text-gold" data-id="element-148" data-mp="2xi2i8e8njm8g">
            <TrendingUp aria-hidden="true" className="h-4 w-4" data-id="element-149" data-mp="3l5art8d45hga" />
            Camino B
          </span>
          <p className="mt-4 text-[14.5px] leading-relaxed text-ash" data-id="element-150" data-mp="3c6fjnqqidxac">
            Adquirir el arsenal visual más completo del mercado por el precio de
            una pizza, unirte a la comunidad líder en Skool y empezar a publicar
            videos que tu competencia ni siquiera entiende cómo hiciste.
          </p>
          <motion.span initial={{
          opacity: 0,
          scale: 2,
          rotate: 18
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 9
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.55,
          delay: 0.38
        }} className="absolute -bottom-2.5 right-5 rounded border-2 border-gold/80 bg-ink/70 px-2.5 py-1 font-mono text-[10px] font-extrabold tracking-[0.14em] text-gold" data-id="element-151" data-mp="24tdgcczrvcvn">
            APROBADO
          </motion.span>
        </motion.article>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.5
    }} transition={{
      duration: 0.6,
      delay: 0.12
    }} className="mt-10 text-center sm:mt-14" data-id="element-152" data-mp="1ei1uzlpkkm2o">
        <CtaButton href={`#${PRIMARY_CTA_ID}`} subLabel="Pago único. Acceso inmediato a todos los bonos." className="w-full sm:w-auto" data-id="element-153" data-mp="1oahi0xfq40uf">
          Sí, quiero disrupción visual ahora — acceso por $11.99
        </CtaButton>
      </motion.div>
    </FilePage>;
}